export default "__VITE_PUBLIC_ASSET__8912deb4__"